import { useTranslation } from 'react-i18next'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useMediaQuery } from 'usehooks-ts'

import { useCoupons } from '@entities/Loyalty'

import { useAuth } from '@features/auth'
import type { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import Wrapper from '@shared/ui/wrapper'

import CouponItem from './coupons/CouponItem'

import couponsStyles from './coupons/styles.module.scss'

export default function CouponsBlock ({ block: _block, payload: _payload, shopId: _shopId }: BlockProps) {
  const { t: tn } = useTranslation('personal')
  const isTablet = useMediaQuery('(max-width: 768px)')
  
  const { isAuthorized } = useAuth()
  const { coupons, loading } = useCoupons({ skip: !isAuthorized })

  if (!isAuthorized || loading || coupons.length === 0) {
    return null
  }

  return (
    <div className={styles.root__coupons}>
      <Wrapper className={couponsStyles.root__wrapper}>
        <div className={couponsStyles.root__content}>
          <h2 className={couponsStyles.root__title}>{tn('coupons.title')}</h2>
          <Swiper
            className={couponsStyles.swiper}
            spaceBetween={12}
            modules={[ Navigation ]}
            navigation={!isTablet}
            breakpoints={{
              768: {
                spaceBetween: 24,
              },
            }}
            slidesPerView={'auto'}
          >
            {coupons.map((coupon) => (
              <SwiperSlide className={couponsStyles.slide} key={coupon.id}>
                <CouponItem coupon={coupon} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Wrapper>
    </div>
  )
}
